
import { h } from 'preact'
import { connectRefinementList } from 'react-instantsearch-dom'
import Count from './ResultsCount'
import Checkbox from '../../../control-components/ui-components/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'
import { SearchHit } from '../types'

type ContentType = 'event' | 'ideation' | 'discussion' | 'question' | 'article' | 'productUpdate'

interface Props {
  items: SearchHit[]
  title: string
  isFromSearch: boolean
  refine: (val: string) => void
  searchForItems: (val: string) => void
  createURL: (val: string) => string
}

const labelMapping: Record<ContentType, JSX.Element | string> = {
  ideation: <Phrase m='Forum' p='topic.form.type.idea.label' />,
  discussion: <Phrase m='Forum' p='topic.form.type.discussion.label' />,
  article: <Phrase m='Forum' p='advanced.search.filter.article' />,
  question: <Phrase m='Forum' p='topic.form.type.question.label' />,
  productUpdate: <Phrase m='Forum' p='topic.form.type.product.updates.label' />,
  event: 'Event'
}

const TopicTypesList = ({
  title,
  items,
  refine
}: Props) => {
  return (
    <div className='instant-search__topic-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      {!items.length
        ? <div class='instant-search__filter-no-results'><Phrase p='No results' m='Control' /></div>
        : <ul>
          {items.map(item => (
            <li key={item.label} className='instant-search__filter-list-item'>
              <div className={`instant-search-filter__label-wrapper ${item.isRefined ? 'refined' : ''}`}>
                <Checkbox
                  label={labelMapping[item.label as ContentType]}
                  onUpdate={() => refine(item.value)}
                  qaClasses='topic-type-checkbox'
                  checked={item.isRefined}
                />
                <Count count={item.count} />
              </div>
            </li>
          ))}
        </ul>}
    </div>
  )
}

export default connectRefinementList(TopicTypesList)
